import { useEffect, useState } from "react";
import api from "../../api";
import { Spinner } from "../../components/Logo";
import { PageHeader } from "../../components/ui";
import { ScrollText } from "lucide-react";

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data.logs)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-audit">
      <PageHeader overline="Security" title="Audit logs" desc="Immutable record of privileged administrative actions." />
      {!logs ? <Spinner /> : logs.length === 0 ? (
        <div className="card p-10 text-center text-slate-500 flex flex-col items-center gap-3"><ScrollText size={28} /> No audit entries yet.</div>
      ) : (
        <div className="card overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead><tr className="text-slate-400 uppercase text-xs tracking-wider border-b border-white/10">
              <th className="py-3 px-4">Actor</th><th className="px-4">Action</th><th className="px-4">Entity</th><th className="px-4">When</th>
            </tr></thead>
            <tbody>
              {logs.map((l, i) => (
                <tr key={i} className="border-b border-white/5 hover:bg-white/5" data-testid={`audit-row-${i}`}>
                  <td className="py-3 px-4 text-[#38bdf8]">{l.actor_email}</td>
                  <td className="px-4"><span className="chip bg-white/5 text-slate-200 font-mono">{l.action}</span></td>
                  <td className="px-4 text-slate-400">{l.entity_type || "—"}</td>
                  <td className="px-4 text-slate-500 text-xs">{new Date(l.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
